var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2056,
    height: 1428,
    viewBox: "0 0 2056 1428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_448)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_245_448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 808.196,
    cy: 854,
    rx: 164.863,
    ry: 385.342,
    transform: "rotate(-19.1089 808.196 854)",
    fill: "url(#paint0_linear_245_448)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_245_448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1156.3,
    cy: 1099.99,
    rx: 457.643,
    ry: 1005.94,
    transform: "rotate(150 1156.3 1099.99)",
    fill: "url(#paint1_linear_245_448)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_245_448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.977,
    cy: 947.252,
    rx: 325.483,
    ry: 526.536,
    transform: "rotate(150 544.977 947.252)",
    fill: "url(#paint2_linear_245_448)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_245_448",
    x: 486.323,
    y: 364.446,
    width: 643.747,
    height: 979.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.7086,
    result: "effect1_foregroundBlur_245_448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_245_448",
    x: 236.923,
    y: -79.9431,
    width: 1838.76,
    height: 2359.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 139.497,
    result: "effect1_foregroundBlur_245_448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_245_448",
    x: -83.5582,
    y: 220.122,
    width: 1257.07,
    height: 1454.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 121.417,
    result: "effect1_foregroundBlur_245_448"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_448",
    x1: 899.001,
    y1: 722.958,
    x2: 812.714,
    y2: 690.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA00D",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58A25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_448",
    x1: 1074.12,
    y1: 1033.28,
    x2: 783.634,
    y2: 2398.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA00D",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620251,
    stopColor: "#F58A25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_448",
    x1: 544.977,
    y1: 420.716,
    x2: 544.977,
    y2: 1473.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC465",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC56F",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2056,
    height: 1428,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient10);
export default __webpack_public_path__ + "static/media/Gradient-10.e63cee48a0834b5d2ac0b74bbfc3cf86.svg";
export { ForwardRef as ReactComponent };